import React from "react";
import { Trans } from "@lingui/macro";
import { getColor } from "../../../../../../utils";
import { ReplyIcon } from "@heroicons/react/outline";
import { LabelList } from "../../../../../../UI/LabelList/LabelList";
import { IContent } from "../../../../../../../model/dashboardOrdersArchive/reducer";
import { numberCurrencyFormat } from "../../../../../../../constants/convertToLocalCurrency";

export type typeRejectedProductsTable = {
  variant?: string;
  dataObject: IContent;
};

export const RejectedProductsTable: React.FC<typeRejectedProductsTable> = ({
  variant,
  dataObject,
}) => {
  const color = getColor(variant);

  const rejectedPrice = dataObject!.rejectedProducts
    ? dataObject!.rejectedProducts.reduce((acc, curr) => {
        return acc + curr.amount * curr.price;
      }, 0)
    : null;

  const products = dataObject.rejectedProducts || [];
  const hasProducts = !!products.length;

  return (
    <div className="mt-4 sm:mt-2.5 py-1.5  grid gap-x-8 sm:col-span-2 grid-cols-1  sm:border sm:rounded-md sm:px-4 overflow-x-auto">
      <span className="flex gap-x-1 font-medium py-1 mb-1.5">
        <span className="text-gray-400">
          <ReplyIcon className="h-6 w-6" />
        </span>
        <Trans>Rejected product</Trans>
      </span>
      <table className="min-w-full divide-y divide-gray-200 border-t">
        <thead className="bg-gray-50">
          <tr className="relative">
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>N%</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>Name</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>Label</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>Count</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>Price for unit</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>VAT</Trans>
            </th>
            <th
              scope="col"
              className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              <Trans>Total price</Trans>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {hasProducts ? (
            products.map((item, index) => {
              let tax;
              if ("tax" in item && item.tax !== null) {
                tax = item.tax;
              } else if (item.product && "vat" in item.product) {
                tax = item.product.vat;
              } else {
                tax = 0;
              }

              return (
                <tr
                  key={index}
                  className={`bg-white hover:bg-${color}-50 align-top`}
                >
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {index + 1}
                  </td>
                  <td className="px-3 py-2 text-sm text-gray-900">
                    {item.productName || item.product?.name || "-"}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
                    <LabelList
                      labelsList={
                        item.labels
                          ? item.labels
                          : item.markedLabels
                            ? item.markedLabels
                            : []
                      }
                    />
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
                    {item?.amount ? item.amount : " - "}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
                    {item?.price ? numberCurrencyFormat(item.price) : " - "}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
                    {tax
                      ? (tax * 100).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                        })
                      : 0}{" "}
                    %
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
                    {numberCurrencyFormat(item.amount * item.price)}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 col-span-9">
                there is no products
              </td>
            </tr>
          )}

          <tr>
            <td
              colSpan={6}
              className="px-3 py-2 whitespace-nowrap text-xs  text-gray-500 col-span-4 text-left"
            >
              <Trans>Total</Trans>:
            </td>
            <td className="px-3 py-2 whitespace-nowrap text-sm   text-gray-900 ">
              {rejectedPrice ? numberCurrencyFormat(+rejectedPrice) : 0}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
